import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useRef, useState, useEffect } from 'react';
import { PrerenderedCanvas } from '@jbrowse/core/ui';
import { bpSpanPx } from '@jbrowse/core/util';
import { observer } from 'mobx-react';
// used so that user can click-away-from-feature below the laid out features
// (issue #1248)
var canvasPadding = 100;
function PileupRendering(props) {
  var onMouseMove = props.onMouseMove,
    blockKey = props.blockKey,
    displayModel = props.displayModel,
    width = props.width,
    height = props.height,
    regions = props.regions,
    bpPerPx = props.bpPerPx,
    sortedBy = props.sortedBy,
    colorBy = props.colorBy;
  var selectedFeatureId = displayModel.selectedFeatureId,
    featureIdUnderMouse = displayModel.featureIdUnderMouse,
    contextMenuFeature = displayModel.contextMenuFeature;
  var _regions = _slicedToArray(regions, 1),
    region = _regions[0];
  var highlightOverlayCanvas = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mouseIsDown = _useState2[0],
    setMouseIsDown = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    movedDuringLastMouseDown = _useState4[0],
    setMovedDuringLastMouseDown = _useState4[1];
  useEffect(function () {
    var _a, _b;
    var canvas = highlightOverlayCanvas.current;
    if (!canvas) {
      return;
    }
    var ctx = canvas.getContext('2d');
    if (!ctx) {
      return;
    }
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    var selectedRect = selectedFeatureId ? (_a = displayModel.getFeatureByID) === null || _a === void 0 ? void 0 : _a.call(displayModel, blockKey, selectedFeatureId) : undefined;
    if (selectedRect) {
      var _selectedRect = _slicedToArray(selectedRect, 4),
        leftBp = _selectedRect[0],
        topPx = _selectedRect[1],
        rightBp = _selectedRect[2],
        bottomPx = _selectedRect[3];
      var _bpSpanPx = bpSpanPx(leftBp, rightBp, region, bpPerPx),
        _bpSpanPx2 = _slicedToArray(_bpSpanPx, 2),
        leftPx = _bpSpanPx2[0],
        rightPx = _bpSpanPx2[1];
      var rectTop = Math.round(topPx);
      var rectHeight = Math.round(bottomPx - topPx);
      ctx.shadowColor = '#222266';
      ctx.shadowBlur = 10;
      ctx.lineJoin = 'bevel';
      ctx.lineWidth = 2;
      ctx.strokeStyle = '#00b8ff';
      ctx.strokeRect(leftPx - 2, rectTop - 2, rightPx - leftPx + 4, rectHeight + 4);
      ctx.clearRect(leftPx, rectTop, rightPx - leftPx, rectHeight);
    }
    var highlightedFeature = featureIdUnderMouse || (contextMenuFeature === null || contextMenuFeature === void 0 ? void 0 : contextMenuFeature.id());
    var highlightedRect = highlightedFeature ? (_b = displayModel.getFeatureByID) === null || _b === void 0 ? void 0 : _b.call(displayModel, blockKey, highlightedFeature) : undefined;
    if (highlightedRect) {
      var _highlightedRect = _slicedToArray(highlightedRect, 4),
        _leftBp = _highlightedRect[0],
        _topPx = _highlightedRect[1],
        _rightBp = _highlightedRect[2],
        _bottomPx = _highlightedRect[3];
      var _bpSpanPx3 = bpSpanPx(_leftBp, _rightBp, region, bpPerPx),
        _bpSpanPx4 = _slicedToArray(_bpSpanPx3, 2),
        _leftPx = _bpSpanPx4[0],
        _rightPx = _bpSpanPx4[1];
      var _rectTop = Math.round(_topPx);
      var _rectHeight = Math.round(_bottomPx - _topPx);
      ctx.fillStyle = '#0003';
      ctx.fillRect(_leftPx, _rectTop, _rightPx - _leftPx, _rectHeight);
    }
  }, [bpPerPx, region, blockKey, selectedFeatureId, displayModel, featureIdUnderMouse, contextMenuFeature]);
  function _onMouseDown(event) {
    setMouseIsDown(true);
    setMovedDuringLastMouseDown(false);
    callMouseHandler('MouseDown', event);
  }
  function _onMouseEnter(event) {
    callMouseHandler('MouseEnter', event);
  }
  function _onMouseOut(event) {
    callMouseHandler('MouseOut', event);
    callMouseHandler('MouseLeave', event);
  }
  function _onMouseOver(event) {
    callMouseHandler('MouseOver', event);
  }
  function _onMouseUp(event) {
    setMouseIsDown(false);
    callMouseHandler('MouseUp', event);
  }
  function _onClick(event) {
    if (!movedDuringLastMouseDown) {
      callMouseHandler('Click', event);
    }
  }
  function _onMouseLeave(event) {
    callMouseHandler('MouseOut', event);
    callMouseHandler('MouseLeave', event);
  }
  function _onContextMenu(event) {
    callMouseHandler('ContextMenu', event);
  }
  function mouseMove(event) {
    if (mouseIsDown) {
      setMovedDuringLastMouseDown(true);
    }
    var offsetX = 0;
    var offsetY = 0;
    var canvas = highlightOverlayCanvas.current;
    if (canvas) {
      var _canvas$getBoundingCl = canvas.getBoundingClientRect(),
        left = _canvas$getBoundingCl.left,
        top = _canvas$getBoundingCl.top;
      offsetX = left;
      offsetY = top;
    }
    offsetX = event.clientX - offsetX;
    offsetY = event.clientY - offsetY;
    var px = region.reversed ? width - offsetX : offsetX;
    var clientBp = region.start + bpPerPx * px;
    var featIdUnderMouse = displayModel.getFeatureOverlapping(blockKey, clientBp, offsetY);
    if (onMouseMove) {
      onMouseMove(event, featIdUnderMouse);
    }
  }
  function callMouseHandler(handlerName, event) {
    // @ts-ignore
    // eslint-disable-next-line react/destructuring-assignment
    var featureHandler = props["onFeature".concat(handlerName)];
    // @ts-ignore
    // eslint-disable-next-line react/destructuring-assignment
    var canvasHandler = props["on".concat(handlerName)];
    if (featureHandler && featureIdUnderMouse) {
      featureHandler(event, featureIdUnderMouse);
    } else if (canvasHandler) {
      canvasHandler(event, featureIdUnderMouse);
    }
  }
  var canvasWidth = Math.ceil(width);
  // need to call this in render so we get the right observer behavior
  return React.createElement("div", {
    className: "PileupRendering",
    "data-testid": "pileup-".concat(sortedBy || colorBy ? "".concat((sortedBy === null || sortedBy === void 0 ? void 0 : sortedBy.type) || '').concat((colorBy === null || colorBy === void 0 ? void 0 : colorBy.type) || '').concat((colorBy === null || colorBy === void 0 ? void 0 : colorBy.tag) || '') : 'normal'),
    style: {
      position: 'relative',
      width: canvasWidth,
      height: height
    }
  }, React.createElement(PrerenderedCanvas, _objectSpread({}, props, {
    style: {
      position: 'absolute',
      left: 0,
      top: 0
    }
  })), React.createElement("canvas", {
    "data-testid": "pileup_overlay_canvas",
    width: canvasWidth,
    height: height + canvasPadding,
    style: {
      position: 'absolute',
      left: 0,
      top: 0
    },
    className: "highlightOverlayCanvas",
    ref: highlightOverlayCanvas,
    onMouseDown: function onMouseDown(event) {
      return _onMouseDown(event);
    },
    onMouseEnter: function onMouseEnter(event) {
      return _onMouseEnter(event);
    },
    onMouseOut: function onMouseOut(event) {
      return _onMouseOut(event);
    },
    onMouseOver: function onMouseOver(event) {
      return _onMouseOver(event);
    },
    onMouseUp: function onMouseUp(event) {
      return _onMouseUp(event);
    },
    onMouseLeave: function onMouseLeave(event) {
      return _onMouseLeave(event);
    },
    onMouseMove: function onMouseMove(event) {
      return mouseMove(event);
    },
    onClick: function onClick(event) {
      return _onClick(event);
    },
    onContextMenu: function onContextMenu(event) {
      return _onContextMenu(event);
    },
    onFocus: function onFocus() {},
    onBlur: function onBlur() {}
  }));
}
export default observer(PileupRendering);